import { CartItem } from "@/types/CarItem";

export interface CustomerData {
  name: string;
  email: string;
  phone: string;
  tax_id: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
}

export function useOrders() {
  const createOrder = async (items: CartItem[], customerData: CustomerData) => {
    try {
      console.log("Criando pedido via Edge Function");

      const response = await fetch(
        "https://fquvvnybdvqonjkmoqbo.functions.supabase.co/create-checkout",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            customer: customerData,
            items: items.map((item) => ({
              product_id: item.product_id,
              quantity: item.quantity,
              color: item.color,
              size: item.size,
            })),
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        console.error("Erro na Edge Function:", data);
        throw new Error(data.error || "Erro ao criar pedido");
      }

      return {
        success: true,
        order_id: data.order_id,
        total: data.total,
      };
    } catch (error) {
      console.error("Erro ao criar pedido:", error);
      throw error;
    }
  };

  return { createOrder };
}
